import React from "react"
import ReactDOM from "react-dom"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"
import store from "./store"
import { isMobile } from "react-device-detect"
import localJsonData from "./assets/localdata.json"

const loader = document.querySelector(".loader")
const showLoader = () => loader.classList.remove("loader--hide")
const hideLoader = () => loader.classList.add("loader--hide")

const renderApp = () => {
  const app = (
    <Provider store={store}>
      <BrowserRouter>
        <App hideLoader={hideLoader} showLoader={showLoader} />
      </BrowserRouter>
    </Provider>
  )

  ReactDOM.render(app, document.getElementById("root"))
}

const fetchAndStoreData = async () => {
  const adminPanel = isMobile
    ? `${process.env.REACT_APP_ADMIN}`
    : `${process.env.REACT_APP_ADMIN_LAPTOP}`
  try {
    const response = await fetch(`${adminPanel}/getJD`)
    const data = await response.json()
    localStorage.removeItem("dataJ")
    localStorage.setItem("dataJ", JSON.stringify(data))
    // --- START PATCH: Redirect root based on admin 'holdingSite' flag ---
    // Added: 20-May-2026 — When visiting the site root, redirect to /home
    // if admin has enabled the holding site; otherwise send to /login.
    // This ensures the live-domain behavior (clicking domain) follows admin toggle.
    try {
      const holding = data?.loginData?.holdingSite
      const atRoot =
        window.location.pathname === "/" ||
        window.location.pathname === "" ||
        window.location.pathname === "/index.html"
      if (atRoot) {
        if (holding) {
          // admin enabled holding site -> go to /home
          window.location.replace("/home")
        } else {
          // admin disabled holding site -> go to /login
          window.location.replace("/login")
        }
      }
    } catch (e) {
      console.warn("redirect check failed", e)
    }
    // --- END PATCH ---
  } catch (error) {
    console.error("Failed to fetch data:", error)
  }
  hideLoader()
  renderApp()
}

showLoader()
fetchAndStoreData()
serviceWorker.unregister()
